<div class="full-page-container">
  <div class="d-block d-lg-none">
    <fgb-page-header [pageTitle]="'wallet.claimed.page.title'" [showBalance]="false" [showQr]="false"></fgb-page-header>
  </div>

  <div class="container pt-4 pt-lg-0">
    <a
      class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
      [routerLink]="'/rewards/wallet'"
    >
      <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
    </a>

    <!-- Items history -->
    <ng-container
      *ngIf="
        {
          walletItemsClaimed: walletItemsClaimed$ | async,
        } as walletItems;
        else noWalletItems
      "
    >
      <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
        <h5 class="m-0 wallet-redeemed-title pb-2 pt-lg-3 pt-0">
          {{ 'wallet.redeemed.item.history.title' | translate }}
        </h5>
        <fgbcl-rewards-wallet-redeemed-list [redeemedItems]="walletItems.walletItemsClaimed"></fgbcl-rewards-wallet-redeemed-list>
      </ng-container>
    </ng-container>

    <ng-template #noWalletItems
      ><div class="no-claim-container bg-white">
        <div class="font-size-12 text-center py-3">
          {{ 'claimed.rewards.placeholder.description' | translate }}
        </div>
      </div>
    </ng-template>
  </div>
</div>
